import { render, staticRenderFns } from "./PublicationBlock.vue?vue&type=template&id=0648c75f&scoped=true"
import script from "./PublicationBlock.vue?vue&type=script&lang=js"
export * from "./PublicationBlock.vue?vue&type=script&lang=js"
import style0 from "./PublicationBlock.vue?vue&type=style&index=0&id=0648c75f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0648c75f",
  null
  
)

export default component.exports